module.exports = __webpack_public_path__ + "static/img/12.415cb349.png";